import { isSameDay } from './isSameDay';
export var isTomorrow = function isTomorrow(date) {
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return isSameDay(tomorrow, new Date(date));
};